// Pure helpers for HdRangeSlider, kept separate so they can be unit-tested
// without mounting the component.

export function clamp(value, min, max) {
  return Math.min(max, Math.max(min, value));
}

// Snap a value to the nearest step measured from `min`. The step can be
// fractional (e.g. (max - min) / 100), so trim the float drift that
// multiplication reintroduces.
export function snapToStep(value, min, step) {
  if (!step || step <= 0) return value;

  const snapped = min + Math.round((value - min) / step) * step;

  return Number(snapped.toFixed(10));
}

export function valueToPercent(value, min, max) {
  if (max <= min) return 0;

  return clamp(((value - min) / (max - min)) * 100, 0, 100);
}

export function percentToValue(percent, min, max) {
  return min + (clamp(percent, 0, 100) / 100) * (max - min);
}

// Resolve a proposed value for one handle: snap to the step, keep it in range,
// and keep the two handles at least `minRange` apart.
export function resolveHandleValue({ handle, value, low, high, min, max, step, minRange }) {
  const snapped = snapToStep(clamp(value, min, max), min, step);

  if (handle === 'low') {
    return clamp(snapped, min, high - minRange);
  }

  return clamp(snapped, low + minRange, max);
}
